module.exports = __webpack_public_path__ + "static/media/ic_userGuide_etung.dfbde4e6.png";